@if (cardInfo(); as cardInfo) {
  <div>
    <mat-card>
      <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
        @if (showAvatar) {
          <div matCardAvatar>
            @if (isFormActivity()) {
              <glxy-avatar
                [width]="AVATAR_WIDTH"
                icon="text_snippet"
                backgroundColor="var(--primary-background-color)"
                textColor="#9E9E9E"
              ></glxy-avatar>
            } @else {
              <glxy-avatar
                [width]="AVATAR_WIDTH"
                icon="sync_alt"
                backgroundColor="var(--primary-background-color)"
                textColor="#9E9E9E"
              ></glxy-avatar>
            }
          </div>
        }
        <mat-card-title>
          @if (headerText()) {
            <span class="title">
              {{ headerText() }}
              @if (isFormActivity()) {
                @if (cardInfo.formLink && cardInfo.formName) {
                  - <a href="{{ cardInfo.formLink }}" target="_blank">{{ cardInfo.formName }}</a>
                } @else if (cardInfo.formName) {
                  - {{ cardInfo.formName }}
                }
              }
            </span>
          } @else {
            <span class="title">{{ 'ACTIVITY.UNKNOWN_TITLE' | translate }}</span>
          }
        </mat-card-title>
        <mat-card-subtitle>
          @if (cardInfo.effectiveDate !== null) {
            <p class="effective-date">
              {{ cardInfo.effectiveDate | date: dateFormat }}
            </p>
          }
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
        @if (isFormActivity()) {
          <mat-card appearance="outlined" class="inner-card">
            <mat-card-content>
              <ng-container [ngTemplateOutlet]="cardContent"></ng-container>
            </mat-card-content>
          </mat-card>
        } @else {
          <ng-container [ngTemplateOutlet]="cardContent"></ng-container>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <ng-template #cardContent>
    @if (cardInfo.noteBody) {
      <div>
        <crm-collapsible-section [maxHeightPx]="100">
          <p class="note-body">
            <span [innerHtml]="cardInfo.noteBody | sanitizeHtml"></span>
          </p>
        </crm-collapsible-section>
      </div>
    }
    @if (cardInfo.activityUrl) {
      <div class="link">
        <a [href]="cardInfo.activityUrl" target="_blank">{{ cardInfo.activityUrlName || cardInfo.activityUrl }}</a>
      </div>
    }
  </ng-template>
}
